const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 210.908 148.237 C 214.626 112.837 238.937 55.556 247.1 38.725 C 256.406 19.551 270.124 20.816 275.756 34.589 C 283.116 52.663 293.61 95.368 296.657 111.759",
    style: {
      fill: "none",
      stroke: "rgb(99, 103, 106)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "6.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 245.824 476.753 C 274.425 476.753 348.624 514.155 391.504 467.424 C 425.869 430.021 413.185 339.892 388.544 279.311 C 379.381 256.76 379.051 235.176 381.383 210.953 C 392.527 95.093 369.381 16.009 330.011 13.841 C 300.441 12.224 300.012 211.91 243.855 200.018 C 187.697 188.126 216.012 8.462 176.51 8.462 C 137.007 8.462 104.731 89.592 110.276 210.92 C 111.376 235.231 112.267 256.727 103.103 279.278 C 78.473 339.892 65.779 429.988 100.144 467.391 C 143.035 514.155 217.277 476.753 245.824 476.753 Z",
    style: {
      fill: "none",
      stroke: "rgb(99, 103, 106)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "6.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 243.69 395.996 C 239.719 417.58 233.899 424.906 222.91 426.798 C 189.556 432.376 163.111 444.52 137.755 426.039",
    style: {
      fill: "none",
      stroke: "rgb(99, 103, 106)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "6.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 229.642 451.594 C 234.152 448.118 238.442 440.373 241.589 435.148 C 245.912 427.832 251.489 425.247 259.827 425.962 C 289.881 428.69 303.433 448.228 332.75 441.044",
    style: {
      fill: "none",
      stroke: "rgb(99, 103, 106)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "6.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 143.112 268.905 C 202.394 247.772 322.882 247.563 356.984 277.705",
    style: {
      fill: "none",
      stroke: "rgb(99, 103, 106)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "6.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/18.78dc8b45.svg";
export { ForwardRef as ReactComponent };